import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Input } from '@ui/components/Input'
import { Modal } from '@ui/components/Modal'

import { isZero } from '@utils/validations'

interface DocumentReasonModalProps {
  onSubmit(reason: string): void
  onCancel?: () => void
  documentType?: string
}

export const DocumentReasonModal: BaseModalType<DocumentReasonModalProps> = ({
  close,
  onSubmit,
  onCancel,
  documentType,
}) => {
  const { t } = useTranslation()
  const [reason, setReason] = useState<string | undefined>()
  const isError = isZero(reason?.trim()?.length)

  const handleCancel = () => {
    onCancel?.()
    close()
  }

  const handleSubmit = () => {
    if (reason && !isError) {
      onSubmit(reason)
      close()
    } else {
      setReason('')
    }
  }

  return (
    <Modal>
      <Modal.Header>{t('Sign up.Tell Us The Reason?')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          {t("Sign up.Please tell us the reason why you can't provide us", { documentType })}
        </Modal.Body.Text>
        <Input
          onChange={(e) => setReason(e.target.value)}
          value={reason}
          label={t('Sign up.Reason')}
          fullWidth
        />
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={handleCancel}>{t('Cancel')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary onClick={handleSubmit}>{t('Submit')}</Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
